export default __webpack_public_path__ + "static/media/arrow.b519ca6c.svg";